export const DEFAULT_COALESCED_REFRESH_DELAY_MS = 200;

export function createCoalescedRefreshState() {
  return {
    timerId: null,
    inFlight: false,
    pending: false,
    latestRefresh: null,
    latestRefreshKey: null,
    inFlightRefreshKey: null,
    pendingRefreshKey: null,
    disposed: false,
  };
}

export function cancelCoalescedRefresh(state) {
  if (!state?.timerId || typeof window === 'undefined') return;

  window.clearTimeout(state.timerId);
  state.timerId = null;
}

export function disposeCoalescedRefresh(state) {
  if (!state) return;

  cancelCoalescedRefresh(state);
  state.disposed = true;
  state.pending = false;
  state.latestRefresh = null;
  state.latestRefreshKey = null;
  state.inFlightRefreshKey = null;
  state.pendingRefreshKey = null;
}

export function scheduleCoalescedRefresh(
  state,
  refresh,
  {
    delayMs = DEFAULT_COALESCED_REFRESH_DELAY_MS,
    immediate = false,
    refreshKey = '',
  } = {}
) {
  if (!state || state.disposed || typeof refresh !== 'function') return;

  const normalizedRefreshKey = String(refreshKey || '').trim();
  state.latestRefresh = refresh;
  state.latestRefreshKey = normalizedRefreshKey;

  const run = async () => {
    state.timerId = null;

    if (state.disposed) return;

    if (state.inFlight) {
      const matchesInFlight = normalizedRefreshKey
        && normalizedRefreshKey === state.inFlightRefreshKey;
      const matchesPending = normalizedRefreshKey
        && state.pending
        && normalizedRefreshKey === state.pendingRefreshKey;

      if (matchesInFlight || matchesPending) {
        return;
      }

      state.pending = true;
      state.pendingRefreshKey = normalizedRefreshKey;
      return;
    }

    state.inFlight = true;
    state.inFlightRefreshKey = normalizedRefreshKey;

    try {
      await state.latestRefresh?.();
    } finally {
      state.inFlight = false;
      state.inFlightRefreshKey = null;

      if (state.pending && !state.disposed) {
        const pendingRefreshKey = state.pendingRefreshKey;
        state.pending = false;
        state.pendingRefreshKey = null;
        scheduleCoalescedRefresh(state, state.latestRefresh, { delayMs, refreshKey: pendingRefreshKey });
      }
    }
  };

  cancelCoalescedRefresh(state);

  if (immediate || typeof window === 'undefined') {
    run();
    return;
  }

  state.timerId = window.setTimeout(run, delayMs);
}
